import React from 'react'
import PropTypes from 'prop-types'
import RichTextOutput from '~/components/RichTextOutput'
import styled from '@emotion/styled'
import { color, device, space } from '@ticketswap/solar'
import { useLanguage } from '~/components/LanguageContext'
import { createEventDateFormatter } from '~/utils'

const Footer = styled.footer`
  color: ${color.spaceLight};
  margin-top: ${space[12]};

  @media ${device.tablet} {
    margin-top: ${space[24]};
  }
`

const BlogPostPageContent = ({ t, blogPost }) => {
  const language = useLanguage()
  const formatDate = createEventDateFormatter(language)

  return (
    <>
      <RichTextOutput body={blogPost.body} />
      <Footer>
        {t('common:generic.authorDate', {
          name: blogPost.author.firstname,
          date: formatDate(blogPost.createdAt),
        })}
      </Footer>
    </>
  )
}

BlogPostPageContent.propTypes = {
  t: PropTypes.func.isRequired,
  blogPost: PropTypes.shape({
    body: PropTypes.string.isRequired,
    author: PropTypes.shape({
      firstname: PropTypes.string.isRequired,
    }).isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
}

export default BlogPostPageContent
